import { render, staticRenderFns } from "./course-action-form.vue?vue&type=template&id=1a46c9b1&"
import script from "./course-action-form.vue?vue&type=script&lang=js&"
export * from "./course-action-form.vue?vue&type=script&lang=js&"
import style0 from "./course-action-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports